import React, { useId } from "react";
import {
  Pill,
  DISPATCH_DARK_HEADER_CHIP_CLASS_NAME,
  DISPATCH_DARK_HEADER_CLASS_NAME,
  DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME,
  joinClasses,
} from "./ResultsPrimitives.jsx";
import { getFleetProductTone } from "../utils/cropColors.js";

const selectedTruckPillClassName = `${DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME} border-border-header-success! bg-[var(--grain-badge-bg)]! px-2! py-0.5! text-[0.62rem] font-semibold! leading-none text-[var(--grain-badge-text)]! shadow-none`;

export default function FleetFilterBar({ countLabel = "0 visibles", query = "", onQueryChange = null, selectedHeaderModel = null }) {
  const inputId = useId();
  const hasQuery = typeof query === "string" && query.trim().length > 0;
  const assignmentName = typeof selectedHeaderModel?.assignmentName === "string"
    ? selectedHeaderModel.assignmentName.trim()
    : "";
  const tripLoad = typeof selectedHeaderModel?.tripLoad === "string"
    ? selectedHeaderModel.tripLoad.trim()
    : "";
  const showSelectedHeader = Boolean(assignmentName);
  // Produits du camion sélectionné : une pastille pleine par produit, aux couleurs du Gantt.
  const tripLoadProducts = tripLoad && tripLoad !== "Aucun chargement"
    ? tripLoad.split(",").map((label) => label.trim()).filter(Boolean)
    : [];

  return (
    <div className="grid gap-1.25 px-0.25 py-0 shadow-none">
      <label className="sr-only" htmlFor={inputId}>Rechercher dans les camions assignés</label>

      <div className={`flex flex-wrap items-center justify-between gap-1.5 ${DISPATCH_DARK_HEADER_CLASS_NAME}`}>
        {showSelectedHeader ? (
          <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-1.5 gap-y-0.5 pr-2">
            <h2
              className="min-w-0 shrink-0 font-display text-[1rem] font-semibold leading-[1.04] tracking-[-0.025em] text-white"
              data-route-target-assignment-name="true"
              title={assignmentName}
            >
              <span className="block truncate">{assignmentName}</span>
            </h2>
            {tripLoadProducts.length ? (
              <span className="flex min-w-0 flex-wrap items-center gap-0.5" data-route-target-trip-load="true" title={tripLoad}>
                {tripLoadProducts.map((label) => {
                  const { accentColor } = getFleetProductTone(label);
                  return (
                    <span
                      key={label}
                      className={`inline-flex shrink-0 items-center border px-1.5 py-0.5 text-[0.62rem] font-semibold leading-none text-white ${DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME}`}
                      style={{ backgroundColor: accentColor, borderColor: accentColor }}
                    >
                      {label}
                    </span>
                  );
                })}
              </span>
            ) : tripLoad ? (
              <Pill tone="success" className={selectedTruckPillClassName} data-route-target-trip-load="true">
                {tripLoad}
              </Pill>
            ) : null}
          </div>
        ) : (
          <span className="text-[0.76rem] font-extrabold uppercase tracking-[0.11em] text-[#eee9e3]">
            CAMIONS ASSIGNÉS
          </span>
        )}
        <span className={DISPATCH_DARK_HEADER_CHIP_CLASS_NAME} data-route-pill="true">
          {countLabel}
        </span>
      </div>

      <div className={`flex min-w-0 items-center gap-1.5 border border-slate-200 bg-white px-2.5 ring-1 ring-slate-100 shadow-[0_3px_10px_rgba(15,23,42,0.03)] transition duration-150 focus-within:border-slate-300 focus-within:ring-slate-200 ${DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME}`}>
        <input
          id={inputId}
          type="search"
          className="min-w-0 flex-1 border-0 bg-transparent py-[0.48rem] text-[0.88rem] leading-[1.25] text-text outline-hidden placeholder:text-[#5f6c80]"
          placeholder="Camion, chauffeur, véhicule, commande..."
          autoComplete="off"
          spellCheck={false}
          value={query}
          onChange={(event) => {
            onQueryChange?.(event.target.value);
          }}
        />
        <button
          type="button"
          className={joinClasses([
            `border border-[rgba(148,163,184,0.18)] bg-white px-2.5 py-1 text-[0.72rem] font-bold text-shell-group-open-toggle-ink transition duration-150 hover:border-border-accent-muted hover:text-accent focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 ${DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME}`,
            hasQuery ? "opacity-100" : "pointer-events-none opacity-0",
          ])}
          aria-hidden={hasQuery ? undefined : "true"}
          disabled={!hasQuery}
          onClick={() => {
            onQueryChange?.("");
          }}
        >
          Effacer
        </button>
      </div>
    </div>
  );
}